"use client";

import React, { useEffect, useState } from "react";
import Spinner from "../../components/Spinner";
import { PORTAL_THEME } from "../../../lib/portal_theme";

const T = PORTAL_THEME;

// Full Service admin sign-in gate. Admin = signed in through the normal
// Shopify customer login as the sales address (FULL_SERVICE_ADMIN_EMAILS,
// default sales@recruitgraphics.com); Shopify verifies the email with a code.
export default function AdminGate({ returnTo, title = "Full Service Admin", children }) {
  const [state, setState] = useState(null);   // { admin, email, adminEmail }

  useEffect(() => {
    fetch("/api/admin/full-service/whoami", { cache: "no-store" })
      .then((r) => r.json()).then(setState)
      .catch(() => setState({ admin: false, email: null }));
  }, []);

  if (!state) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: T.fontFamily, color: T.textMuted, gap: 10 }}>
        <Spinner size={18} />Checking login…
      </div>
    );
  }
  if (state.admin) return children;

  const signIn = (prompt) => `/api/customer/auth/start?returnTo=${encodeURIComponent(returnTo)}${prompt ? `&prompt=${prompt}` : ""}`;
  const switchAccount = async () => {
    await fetch("/api/customer/auth/logout", { method: "POST", credentials: "include" }).catch(() => {});
    window.location.href = signIn("login");
  };
  const btn = {
    display: "block", width: "100%", padding: "12px 0", borderRadius: 0, textAlign: "center", cursor: "pointer",
    background: T.chromeGradient, textTransform: "uppercase", letterSpacing: "1px", color: T.chromeButtonText, border: T.chromeBorder, boxShadow: T.chromeButtonShadow,
    fontWeight: 700, fontSize: 14, fontFamily: T.fontFamily, textDecoration: "none",
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", padding: "80px 24px", fontFamily: T.fontFamily, color: T.text }}>
      <div style={{ width: "100%", maxWidth: 400, padding: "32px 28px", background: T.cardBackground, border: T.cardEdge, borderRadius: 0, height: "fit-content" }}>
        <h1 style={{ fontSize: 20, fontWeight: 800, margin: "0 0 8px" }}>{title}</h1>
        {state.email ? (
          <>
            <p style={{ color: T.textMuted, fontSize: 14, lineHeight: 1.6, margin: "0 0 20px" }}>
              You&apos;re signed in as <strong style={{ color: T.text }}>{state.email}</strong>. Sign in as {state.adminEmail} to continue.
            </p>
            <button type="button" onClick={switchAccount} style={btn}>Switch account →</button>
          </>
        ) : (
          <>
            <p style={{ color: T.textMuted, fontSize: 14, lineHeight: 1.6, margin: "0 0 20px" }}>
              Sign in with <strong style={{ color: T.text }}>{state.adminEmail}</strong>. Shopify will email that address a sign-in code.
            </p>
            <a href={signIn()} style={btn}>Sign in →</a>
          </>
        )}
      </div>
    </div>
  );
}
